module.exports = __webpack_public_path__ + "static/antd-datepicker-sizes-a0539d6a1bec03c92bd56e043f9f30aa.png";